module.exports = __webpack_public_path__ + "static/descriptive-icons-desktop-d5051fc3dc02afff59d97ed88b2e7d34.png";